module.exports = __webpack_public_path__ + "favicon.ico"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/icons/favicon.ico
 ** module id = 608
 ** module chunks = 0
 **/